module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/banner--learn-6a1eb49e9072a71a0031dd879cf67606.jpg";